import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component } from '@angular/core';

import { NotificationService } from '../../../core/services/common/notification.service';
import { NotificationModel } from '../../../core/models/internals/notification.model';

@Component({
    selector: 'app-toast-2',
    imports: [CommonModule, RouterModule],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {

  constructor(
    private notificationService: NotificationService
  ) { }

  public removeNotification(notification: NotificationModel): void {
    this.notificationService.removeNotification(notification);
  }

  get notifications(): NotificationModel[] {
    return this.notificationService.notifications;
  }
}
